module.exports = __webpack_public_path__ + "img/404.01d4ccb4.png";